export enum PRODUCT_SORTING_OPTIONS {
  PRICE_ASC = 'PRICE_ASC',
  PRICE_DESC = 'PRICE_DESC',
  DISCOUNT_DESC = 'DISCOUNT_DESC',
  ALPHABETICALLY_ASC = 'ALPHABETICALLY_ASC',
  ALPHABETICALLY_DESC = 'ALPHABETICALLY_DESC',
  CREATED_ASC = 'CREATED_ASC',
  CREATED_DESC = 'CREATED_DESC',
  UPDATED_ASC = 'UPDATED_ASC',
  UPDATED_DESC = 'UPDATED_DESC'
}